import {useEffect} from 'react'

export const useDidMount = (func) => {
    useEffect(() => {
        func()
    }, []) // eslint-disable-line
}